import { dom } from "../dom";

const RING_CIRCUMFERENCE = 314.16; // 2 * π * 50

/**
 * Управляет полноэкранным прогресс-оверлеем с круговым спиннером.
 *
 * - `setProgress(pct, text)` показывает определённый прогресс 0–100%.
 * - `setProgress(null, text)` показывает анимированный спиннер без процентов
 *   (неопределённый режим) — для этапов без известного объёма работы.
 * - `hideProgress()` скрывает виджет.
 */
export function setProgress(percent: number | null, statusText?: string): void {
  const hasText = statusText !== undefined && statusText !== null;
  dom.progressOverlay.setAttribute("aria-hidden", "false");

  if (percent === null || percent === undefined || !Number.isFinite(percent)) {
    dom.progressOverlay.classList.add("is-active");
    dom.progressOverlay.classList.add("is-indeterminate");
    dom.progressRingFill.style.strokeDashoffset = String(RING_CIRCUMFERENCE * 0.25);
    dom.progressRingPct.textContent = "";
    dom.progressLabel.textContent = hasText ? String(statusText) : "Обработка…";
    return;
  }

  const clamped = Math.max(0, Math.min(100, percent));
  const offset = RING_CIRCUMFERENCE * (1 - clamped / 100);

  dom.progressOverlay.classList.add("is-active");
  dom.progressOverlay.classList.remove("is-indeterminate");
  dom.progressRingFill.style.strokeDashoffset = String(offset);
  dom.progressRingPct.textContent = `${Math.round(clamped)}%`;
  dom.progressLabel.textContent = hasText ? String(statusText) : `${Math.round(clamped)}%`;
}

export function hideProgress(): void {
  dom.progressOverlay.classList.remove("is-active");
  dom.progressOverlay.classList.remove("is-indeterminate");
  dom.progressOverlay.setAttribute("aria-hidden", "true");
  dom.progressRingFill.style.strokeDashoffset = String(RING_CIRCUMFERENCE);
  dom.progressRingPct.textContent = "";
  dom.progressLabel.textContent = "";
}
